<template>
  <div>
    <h1 class="mb-2 mt-1">
      Underlying Data
    </h1>

    <!-- Priority Underlyings Table -->
    <b-card class="mb-2 principal-underlyings-card-with-hint">
      <hint-popup
        :id="12"
        class="principal-underlyings-hint-popup"
      />
      <h3 class="mb-2 principal-underlyings-title">
        {{ priorityGroupLabel }}
      </h3>

      <loading-container
        v-if="loading"
      />
      <error-display
        v-else-if="error"
        @action-clicked="loadData"
      />
      <NoDataContainer
        v-else-if="!priorityItems || priorityItems.length < 1"
      />
      <b-table
        v-else
        responsive="sm"
        hover
        :items="priorityItems"
        :fields="fields"
        @row-clicked="rowClicked"
      >
        <template #cell(name)="data">
          <span>{{ data.item.name }}</span>
        </template>
      </b-table>
    </b-card>

    <!-- All Underlyings Table -->
    <category-summary-table
      category="underlying"
      route-name="underlying-details"
      param-name="uid"
      name-label="Underlying"
    >
      <template #title>
        All Underlyings
      </template>
    </category-summary-table>
  </div>
</template>

<script>
import { BCard, BTable } from 'bootstrap-vue'
import LoadingContainer from '@/views/components/LoadingContainer.vue'
import ErrorDisplay from '@/views/components/ErrorDisplay.vue'
import NoDataContainer from '@/views/components/NoDataContainer.vue'
import HintPopup from '@/views/components/HintPopup.vue'
import CategorySummaryTable from './CategorySummaryTable.vue'

export default {
  components: {
    CategorySummaryTable,
    BCard,
    BTable,
    LoadingContainer,
    ErrorDisplay,
    NoDataContainer,
    HintPopup,
  },
  data() {
    return {
      allItems: [],
      fields: [],
      underlyingFilterCategoryGroups: null,
      loading: false,
      error: false,
    }
  },
  computed: {
    priorityGroup() {
      return this.underlyingFilterCategoryGroups?.underlying?.[0] || null
    },
    priorityGroupLabel() {
      return this.priorityGroup?.groupLabel || ''
    },
    priorityIds() {
      return this.priorityGroup?.values || []
    },
    priorityItems() {
      const items = []
      this.priorityIds.forEach(id => {
        const item = this.allItems.find(i => String(i.id) === String(id))
        if (item) {
          items.push(item)
        }
      })
      return items
    },
  },
  mounted() {
    this.loadData()
    this.loadUnderlyingFilterCategoryGroups()
  },
  methods: {
    loadUnderlyingFilterCategoryGroups() {
      this.$http
        .get('public.cfc?method=getUnderlyingFilterCategoryGroups')
        .then(response => {
          this.underlyingFilterCategoryGroups = response.data
        })
        .catch(error => {
          console.error('Error fetching underlying filter category groups:', error)
        })
    },
    loadData() {
      this.loading = true
      this.error = false

      this.$http
        .get('public.cfc?method=getCategorySummary&category=underlying')
        .then(response => {
          console.log('Category Summary for underlying:', response.data)
          this.allItems = response.data.CONTENT

          if (response.data.HEADER && response.data.HEADER.length > 0) {
            const columnOrder = ['name', 'count', 'active', 'current']

            this.fields = response.data.HEADER
              .filter(header => header.key !== 'link')
              .sort((a, b) => {
                const indexA = columnOrder.indexOf(a.key)
                const indexB = columnOrder.indexOf(b.key)
                // If not in columnOrder, put at end
                if (indexA === -1) return 1
                if (indexB === -1) return -1
                return indexA - indexB
              })
              .map(header => ({
                key: header.key,
                label: header.key === 'name' ? 'Underlying' : header.label,
                sortable: true,
                thStyle: { width: header.key === 'name' ? '50%' : '20%' },
              }))
          }
        })
        .catch(error => {
          console.error('Error fetching category summary:', error)
          this.error = true
        })
        .finally(() => {
          this.loading = false
        })
    },
    rowClicked(row) {
      this.$router.push({
        name: 'underlying-details',
        params: {
          uid: row.id,
        },
      })
    },
  },
}
</script>

<style scoped>
.principal-underlyings-card-with-hint ::v-deep .card-body {
  position: relative;
}

.principal-underlyings-hint-popup {
  position: absolute;
  top: 1rem;
  right: 1rem;
  z-index: 2;
}

.principal-underlyings-title {
  padding-right: 2.5rem;
}
</style>
